// Dashboard.jsx
import { Container } from "react-bootstrap";
import "./dashboard.css";

import { useDashboardData } from "./useDashboardData.js";

import DashboardHeader from "./dashboardHeader.js";
import DashboardStats from "./dashboardStats.js";
import DashboardLineChart from "./dashboardLineChart.js";

export default function Dashboard26() {
  const stats = useDashboardData();

  return (
    <Container className="dashboard-container">
      <div className="dashboard-card">
        <DashboardHeader />
        
        <DashboardStats stats={stats} />
        
        <div>Metricas Promedio ventas mensuales
         <DashboardLineChart data={stats.promedio} />
        </div>
       
      </div>
    </Container>
  );
}